import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

export type ResponseType = {
  mineCount: number
  contributingCount: number
  globalCount: number
  myPlantCount?: number
}

export const QueryKey = 'analysis-list-counts'

export const useGetAnalysisListCounts = (
  plantUpmId: string,
  options?: UseQueryOptions<ResponseType, AxiosError>
) => {
  return useQuery<ResponseType, AxiosError>({
    queryKey: [QueryKey, plantUpmId],
    queryFn: async () => {
      const path = '/rootcausefailureanalysis/analyses/userstatistics'
      return (await ApiClient.axiosInstance.post<ResponseType>(path, {plantUpmId}, {})).data
    },
    // these default values will get moved to the api provider soon
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: false,

    // allow the callee to override the default options
    ...options
  })
}
